/* paex-shipping-sheet.js — Free shipping offer - PE "see details" flyout
   (snippets/paex-shipping-sheet.liquid). Opens the sheet on any
   [data-ssh-open][aria-controls] link (the link keeps working without JS),
   then, once per session, fetches the shipping page named by the sheet's
   data-ssh-src, lifts its Shipping rates - PE section (the real table: province
   select, prices, offer cells, caption, #free-shipping footnote) into the sheet
   and loads paex-shipping.css + paex-shipping.js on demand so the same
   <paex-shipping-rates> element paints the same prices. The offer engine's zone
   (window.paexShippingOffer) marks "Your zone" through paex:shipping-resolve.
   The section key (data-ssh-section) and the mode (section | page | link) are
   Theme settings (Sasha 2026-10-19: "I would like to be able to decide what the
   drawer is"); mode page is server-rendered and needs no fetch. Nothing is
   cached in storage — a theme change shows at the next open. */
(function () {
  if (window.paexShipSheet) return;
  var mem = {}; // src+key -> html, this page view only (a theme change must show at once)
  var loading = {};

  function say(sheet, text) {
    var live = sheet.querySelector('[data-ssh-live]');
    if (live && text) { live.textContent = ''; live.textContent = text; }
  }

  // the shipping sections need their own stylesheet + script (same custom
  // elements, same prices); any other section comes with its inline styles only
  function ensureAssets(sheet, html) {
    if (!/paex-shipping/.test(html)) return;
    var css = sheet.getAttribute('data-ssh-css');
    var js = sheet.getAttribute('data-ssh-js');
    if (css && !document.querySelector('link[href*="paex-shipping.css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = css;
      document.head.appendChild(link);
    }
    if (js && !customElements.get('paex-shipping-rates') && !document.querySelector('script[src*="paex-shipping.js"]')) {
      var script = document.createElement('script');
      script.src = js;
      script.defer = true;
      document.head.appendChild(script);
    }
  }

  function extract(text, key) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var section = doc.querySelector('[id$="__' + key + '"]') || doc.getElementById('shopify-section-' + key);
    if (!section) return '';
    var root = section.firstElementChild;
    while (root && /^(LINK|STYLE|SCRIPT)$/.test(root.tagName)) root = root.nextElementSibling;
    if (!root) return '';
    root.querySelectorAll('script:not([type="application/json"])').forEach(function (node) { node.remove(); });
    root.querySelectorAll('link[rel="stylesheet"]').forEach(function (node) { node.remove(); });
    Array.prototype.slice.call(root.classList).forEach(function (name) {
      if (/^section-.*-padding$/.test(name)) root.classList.remove(name);
    });
    // keep the section's own <style data-shopify> blocks (colour / spacing), minus the page padding class above
    var styles = '';
    section.querySelectorAll(':scope > style').forEach(function (node) { styles += node.outerHTML; });
    return styles + root.outerHTML;
  }

  function fetchSection(sheet) {
    var src = sheet.getAttribute('data-ssh-src') || '';
    var key = sheet.getAttribute('data-ssh-section') || 'shipping_rates';
    var id = src + '#' + key;
    if (mem[id]) return Promise.resolve(mem[id]);
    if (!src) return Promise.resolve('');
    // same origin only: the Offer details link is a merchant URL setting (review 2026-10-19)
    try { if (new URL(src, location.href).origin !== location.origin) return Promise.resolve(''); } catch (error) { return Promise.resolve(''); }
    if (!loading[id]) {
      loading[id] = fetch(src, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (text) { var html = text ? extract(text, key) : ''; if (html) mem[id] = html; return html; })
        .catch(function () { return ''; })
        .then(function (html) { delete loading[id]; return html; });
    }
    return loading[id];
  }

  // "Your zone" row + province from the offer engine (the page's own checker is
  // not here): one paex:shipping-resolve per state, exact only when the engine is
  function resolveZone() {
    var engine = window.paexShippingOffer;
    if (!engine || !engine.state) return;
    var state = engine.state;
    if (!state.region && !state.zone) return;
    document.dispatchEvent(new CustomEvent('paex:shipping-resolve', {
      detail: { region: state.region || null, zone: state.zone || null, postal: state.postal || null, mode: state.confidence === 'exact' ? 'exact' : 'province', soft: state.confidence !== 'exact' }
    }));
  }

  function load(sheet) {
    var content = sheet.querySelector('[data-ssh-content]');
    if (!content || content.hasAttribute('data-ssh-loaded') || content.hasAttribute('data-ssh-loading')) return;
    var skeleton = sheet.querySelector('[data-ssh-skeleton]');
    var error = sheet.querySelector('[data-ssh-error]');
    content.setAttribute('data-ssh-loading', '');
    fetchSection(sheet).then(function (html) {
      content.removeAttribute('data-ssh-loading');
      if (!html) {
        if (skeleton) skeleton.hidden = true;
        if (error) error.hidden = false;
        return;
      }
      ensureAssets(sheet, html);
      content.innerHTML = html; // same-origin theme markup, scripts stripped
      content.hidden = false;
      content.setAttribute('data-ssh-loaded', '');
      if (skeleton) skeleton.hidden = true;
      say(sheet, content.getAttribute('data-loaded-text'));
      if (!content.querySelector('paex-shipping-rates')) return;
      var apply = function () { requestAnimationFrame(resolveZone); };
      if (customElements.get('paex-shipping-rates')) apply();
      else customElements.whenDefined('paex-shipping-rates').then(apply);
    });
  }

  // the links open a dialog only while the sheet exists on the page: say so to AT
  // (without JS they stay honest page links)
  function affordance(root) {
    (root || document).querySelectorAll('[data-ssh-open][aria-controls]').forEach(function (link) {
      var sheet = document.getElementById(link.getAttribute('aria-controls'));
      if (sheet && typeof sheet.show === 'function') { link.setAttribute('aria-haspopup', 'dialog'); link.setAttribute('aria-expanded', 'false'); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { affordance(document); });
  else affordance(document);

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-ssh-open]');
    if (!opener) return;
    var id = opener.getAttribute('aria-controls');
    var sheet = id && document.getElementById(id);
    if (!sheet || typeof sheet.show !== 'function') return; // no sheet on this page: the link navigates
    event.preventDefault();
    sheet.show(opener);
    load(sheet);
  });

  document.addEventListener('paex:offer-change', function () {
    if (document.querySelector('[data-ssh-content][data-ssh-loaded] paex-shipping-rates')) resolveZone();
  });

  window.paexShipSheet = { load: load, resolveZone: resolveZone };
})();
